enum MovingPageDirection {
  Forward,
  Backward,
}

export default MovingPageDirection;
